/*
 * Copyright (c) 2025 Bolmate B.V.
 */

import {useEffect, useState} from 'react';

import {breakpointService, BreakpointState} from './breakpointService';

export function useBreakpoint(): BreakpointState {
    const [state, setState] = useState(breakpointService.getSnapshot);

    useEffect(() => {
        return breakpointService.subscribe(() => {
            setState(breakpointService.getSnapshot());
        });
    }, []);

    return state;
}
